import { getAllMessages } from "@/shared/i18n/locales";
import { createI18n } from "vue-i18n";

type AppI18n = ReturnType<typeof setupI18n>;

function setupI18n(messages: ReturnType<typeof getAllMessages>) {
    return createI18n({
        fallbackLocale: ["en"],
        globalInjection: true, // wird für die Nutzung von $t im Template benötigt
        legacy: false, // wird für die Nutzung in der setup Funktion benötigt
        locale: "en",
        messages,
        warnHtmlMessage: false,
        missing(_locale: string, key: string) {
            return key.split(".").slice(1).join(".");
        },
    });
}

let i18n: AppI18n | null = null;

export function getI18n(): AppI18n {
    if (i18n === null) {
        i18n = setupI18n(getAllMessages());
    }
    return i18n;
}
